import { z } from "zod";

export const SyncResourceSchema = z.enum(["menu", "orders"]);
export type SyncResource = z.infer<typeof SyncResourceSchema>;

export const TombstoneSchema = z.object({
  resource: z.string(),
  resourceId: z.string().uuid(),
  deletedAt: z.string().datetime(),
});
export type Tombstone = z.infer<typeof TombstoneSchema>;

export const SyncResponseSchema = z.object({
  resource: SyncResourceSchema,
  upserts: z.array(z.record(z.unknown())),
  tombstones: z.array(TombstoneSchema),
  cursor: z.string().datetime(),
  hasMore: z.boolean(),
});
export type SyncResponse = z.infer<typeof SyncResponseSchema>;
